<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <!-- <b-col lg="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button
            class="mr-2"
            type="submit"
            size="md"
            variant="primary"
            @click="newEntity"
          >
            <i class="fa fa-plus"></i>
            New Product
          </b-button>
        </div>
        <div>
          <StyledDialog
            @filterList="filterList"
            :CurrentObject="mySelected"
            EntityType="Product"
          >
            <div slot="header">
              <h2>{{ mySelected.ProductName }}</h2>
            </div>
            <div slot="details">
              <div>{{ mySelected.ProductShortDesc }}</div>
            </div>
            <span slot="entityType">Product</span>
          </StyledDialog>
        </div>
      </b-col> -->
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          :tbody-tr-class="rowClass"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRows"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "InventoryProductList",
  data: () => {
    return {
      fields: [
        {
          key: "ProductName",
          label: "Product",
          sortable: true,
          thStyle: "width: 30%;"
        },
        {
          key: "ProductShortDesc",
          label: "Description",
          sortable: true,
          thStyle: "width: 30%;"
        },
        {
          key: "ProductSku",
          label: "Sku",
          sortable: true,
          thStyle: "width: 15%;"
        },
        {
          key: "QuantityInStock",
          label: "Available",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "ReorderLevel",
          label: "Reorder",
          sortable: true,
          thStyle: "width: 10%;"
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: ""
    };
  },
  props: {},
  components: {
    cTable,
    StyledDialog
    //MyBaseTable
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.product.products.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["product", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.ReorderLevel > item.QuantityInStock) return "table-danger";
    },
    async myLoadComponent() {
      await this.$store.dispatch("product/fetchProducts");
      this.filterList();
    },
    async myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      await this.$store
        .dispatch("product/loadProductEdit", record.ProductID)
        .then(() => {
          this.$router.push({ name: "TransactionList" });
        });
    },
    newEntity() {
      this.$store
        .dispatch("product/newProduct", this.createFreshObject())
        .then(() => {
          this.$router.push({ name: "Product" });
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshObject() {
      return {
        ProductID: -1,
        ProductName: "",
        ProductDesc: "",
        ProductShortDesc: "",
        Inactive: false
      };
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.product.products.filter(
        product =>
          product.ProductName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          product.ProductSku.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          product.ProductShortDesc.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          product.ProductDesc.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
